import { AppState } from 'state/types';

import getParentState from '../selectors';

export function getDownloadState(state: AppState) {
  return getParentState(state).download;
}

export default getDownloadState;
